export const enecoProgressIndicatorTokensColors = {
  progressIndicatorItemDefault: '{{ neutralColors.neutral400 }}',
  progressIndicatorItemDisabled: '{{ neutralColors.neutral300 }}',
  progressIndicatorItemActive: '{{ linkColors.linkBrand }}',
  progressIndicatorItemBorderColor: '{{ linkColors.linkBrand }}',
};
